import script from "./StatsCharts.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsCharts.vue?vue&type=script&setup=true&lang=js"

import "./StatsCharts.vue?vue&type=style&index=0&id=1546f76f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1546f76f"]])

export default __exports__